import Carousel from 'embla-carousel';
import {ready} from '../main/utils';
import loadProductDiagrams from './diagrams';
import loadAerDec from './aer-dec';
import loadToggler from './toggler';
import loadNSF from './nsf';
import loadSloScroller from './scroller';
import loadSloExplode from './explode';
import loadSubnav from './subnav';
import ClassNames from 'embla-carousel-class-names';

ready(() => {
  const carouselNodes = Array.from(document.querySelectorAll('.page-touch-free--innovation--carousel'));

  function createCarousel(node) {
    const classnameOptions = {
      draggable: 'cursor-grab',
      dragging: 'cursor-grabbing'
    };

    const carousel = Carousel(node, {
      loop: true
    }, [ClassNames(classnameOptions)]);

    function onCarouselSelect() {
      const index = carousel.selectedScrollSnap();
      carousel.slideNodes().forEach((el, i) => el.classList.toggle('is-active', i === index));
    }

    const setupDotBtns = (dotsArray, embla) => {
      dotsArray.forEach((dotNode, i) => {
        dotNode.addEventListener('click', () => embla.scrollTo(i), false);
      });
    };

    const generateDotBtns = (dots, embla) => {
      const button = '<button type="button" class="page-touch-free--innovation--carousel--dot"></button>';
      dots.innerHTML = embla.scrollSnapList().reduce(acc => acc + button, '');
      return Array.from(dots.querySelectorAll('.page-touch-free--innovation--carousel--dot'));
    };

    const selectDotBtn = (dotsArray, embla) => () => {
      const previous = embla.previousScrollSnap();
      const selected = embla.selectedScrollSnap();
      dotsArray[previous].classList.remove('is-selected');
      dotsArray[selected].classList.add('is-selected');
    };

    const dots = node.querySelector('.page-touch-free--innovation--carousel--dots');
    const dotsArray = generateDotBtns(dots, carousel);
    const setSelectedDotBtn = selectDotBtn(dotsArray, carousel);

    onCarouselSelect();
    setupDotBtns(dotsArray, carousel);

    carousel.on('select', onCarouselSelect);
    carousel.on('select', setSelectedDotBtn);
    carousel.on('init', setSelectedDotBtn);
  }

  carouselNodes.forEach(createCarousel);

  loadProductDiagrams();
  loadAerDec();
  loadToggler();
  loadSloScroller();
  loadSloExplode();
  loadSubnav();
  loadNSF();
});
